import { SchemaSettingField } from 'types/Schema';

export const isStyleBoxSmallFn = (setting: SchemaSettingField[], index: number) => {
  return (
    setting[index].type === 'styleBox' &&
    (setting[index + 1]?.type === 'text' || setting[index + 1]?.type === 'richText' || setting[index + 1]?.type === 'icon')
  );
};
